import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

interface RealTimeClockProps {
  lastUpdate?: string
  timeFormat?: string
  withSeconds?: boolean
}

export const RealTimeClock: React.FC<RealTimeClockProps> = ({
  lastUpdate,
  timeFormat = 'ru-RU',
  withSeconds = true
}) => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="glass-panel rounded-2xl p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="text-2xl">🕐</div>
        <h3 className="text-lg font-semibold">Время системы</h3>
      </div>
      <motion.div
        key={currentTime.toISOString()}
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        className="text-4xl font-bold font-mono"
      >
        {currentTime.toLocaleTimeString(timeFormat, {
          hour: '2-digit',
          minute: '2-digit',
          second: withSeconds ? '2-digit' : undefined
        })}
      </motion.div>
      {lastUpdate && (
        <div className="mt-4 text-sm text-gray-500">
          Обновлено: {lastUpdate}
        </div>
      )}
    </div>
  )
}